<template>
  <v-card v-if="files.length > 0" :elevation="$vuetify.breakpoint.xsOnly ? 0 : ''" class="mb-4">
    <v-card-title class="subtitle-1 text-uppercase font-weight-medium">
      <v-icon class="mr-2">mdi-folder-zip-outline</v-icon>
      {{ $t('offers.material.title') }}
    </v-card-title>
    <v-card-text>
      <div class="caption grey--text mb-2">{{ $t('offers.material.info') }}</div>
      <offer-file-list
        :files="files"
        :zip="zip"
        :zip-name="$t('offers.material.title')"
        readonly
        @open="open"
        @download="download"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import quotationApi from '@/api/quotation';
import { openFile, downloadFile } from '@/helpers/fileOpen';
import OfferFileList from '@/components/Offers/OfferFileList';

// Projektin tilatun tarjouksen tarjouspyyntöaineisto työmaalla; tiedostot ovat tarjouksella, joten vain luku
export default {
  name: 'SiteOfferMaterial',
  components: { OfferFileList },
  props: {
    projectId: { type: Number, required: true },
  },
  data() {
    return { files: [] };
  },
  watch: {
    projectId: {
      immediate: true,
      async handler(projectId) {
        try {
          this.files = await quotationApi.getProjectMaterial(projectId);
        } catch (error) {
          this.$handleApiError(error, this.$t('offers.attachments.load_failed'));
        }
      },
    },
  },
  methods: {
    async open(file) {
      try {
        await openFile(this, file);
      } catch (error) {
        this.$handleApiError(error, this.$t('offers.attachments.load_failed'));
      }
    },
    zip(folder) {
      return quotationApi.downloadProjectMaterialZip(this.projectId, folder);
    },
    async download(file) {
      try {
        await downloadFile(this, file);
      } catch (error) {
        this.$handleApiError(error, this.$t('offers.attachments.load_failed'));
      }
    },
  },
};
</script>
